import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { ActivatedRouteModel } from '@modules/common/models/activated-route-model';

@Injectable({
    providedIn: 'root'
})
export class RouteModelService {
    /**
     * Transform an Angular ActivatedRouteSnapshot
     * into the custom ActivatedRouteModel
     */
    public getRouteModel(activatedRouteSnapshot: ActivatedRouteSnapshot): ActivatedRouteModel {
        let route: ActivatedRouteSnapshot | null = activatedRouteSnapshot;

        const result = <ActivatedRouteModel>{
            params: {},
            queryParams: {},
            urlWithParameterPlaceholders: [],
            urlWithPopulatedParameters: [],
        };

        if (route && route!.queryParams!) {
            for (let k in route!.queryParams!) {
                result.queryParams[k] = route!.queryParams[k];
            }
        }

        while (route && route.parent) {
            route = route.parent;
        }

        while (route) {
            var split = route.routeConfig
                && route.routeConfig.path
                && route.routeConfig.path.split('/');

            if (split && split.length && route.url && route.url.length == split.length) {
                for (let i = 0; i < split.length; i++) {
                    result.urlWithParameterPlaceholders.push(split[i]);
                    result.urlWithPopulatedParameters.push(route.url[i].path);
                }
            }

            if (route.params) {
                for (let k in route.params) {
                    result.params[k] = route.params[k];
                }
            }

            if (route.data) {
                result.data = Object.assign(result.data || {}, route.data);
            }

            route = route.firstChild;
        }

        return result;
    }
}
